document.addEventListener("DOMContentLoaded", function () {
  const productGrid = document.getElementById("hydrx-product-grid");
  const trackerList = document.getElementById("tracker-list");
  const addToCartBtn = document.getElementById("add-bundle-to-cart");
  const discountNote = document.getElementById("discount-note");
  const totalPriceDisplay = document.getElementById("bundle-total");
  const countDisplay = document.getElementById("bundle-count");

  const maxFlavors = 3;
  const pricePerPack = 24.99;

  let selectedVariants = [];

  const variants = [
    {
      id: 50586379125037,
      title: "Lemon-Lime",
      subtitle: "Electrolytes",
      image: "https://cdn.shopify.com/s/files/1/0900/3696/1581/files/LemonLime-Box_1.png?v=1743104782"
    },
    {
      id: 50586379157805,
      title: "Orange-Pineapple",
      subtitle: "Electrolytes",
      image: "https://cdn.shopify.com/s/files/1/0900/3696/1581/files/OrangePineapple-Box.png?v=1743104781"
    },
    {
      id: 50586379190573,
      title: "Watermelon",
      subtitle: "Electrolytes",
      image: "https://cdn.shopify.com/s/files/1/0900/3696/1581/files/Watermelon-Box.png?v=1743104781"
    },
    {
      id: 50586379223341,
      title: "Grape",
      subtitle: "Electrolytes",
      image: "https://cdn.shopify.com/s/files/1/0900/3696/1581/files/Grape-Box.png?v=1743104781"
    }
  ];

  function renderProducts() {
    productGrid.innerHTML = "";
    variants.forEach(variant => {
      const card = document.createElement("div");
      card.className = "product-box";
      card.innerHTML = `
        <img src="${variant.image}" alt="${variant.title}" class="product-image" />
        <div class="product-title">${variant.title}</div>
        <div class="product-subtitle">${variant.subtitle}</div>
        <button class="add-to-bundle"
          data-id="${variant.id}"
          data-title="${variant.title}"
          data-subtitle="${variant.subtitle}"
          data-image="${variant.image}">
          Add to Bundle
        </button>
      `;
      productGrid.appendChild(card);
    });
  }

  function updateTracker() {
    trackerList.innerHTML = "";

    for (let i = 0; i < maxFlavors; i++) {
      const item = selectedVariants[i];
      const slot = document.createElement("div");
      slot.className = "bundle-slot";

      if (item) {
        slot.innerHTML = `
          <div class="slot-inner">
            <div class="slot-image"><img src="${item.image}" alt="${item.title}" /></div>
            <div class="slot-info">
              <div class="slot-title">${item.title}</div>
              <div class="slot-subtitle">${item.subtitle}</div>
              <div class="slot-price">$${pricePerPack.toFixed(2)}</div>
            </div>
            <button class="remove-item" data-index="${i}">×</button>
          </div>
        `;
      } else {
        slot.innerHTML = `
          <div class="slot-inner">
            <div class="slot-inner empty-slot">
              <div class="slot-info">
                <div class="slot-title">Choose a Flavor</div>
              </div>
            </div>
          </div>
        `;
      }

      trackerList.appendChild(slot);
    }

    // Update flavor count
    if (countDisplay) {
      countDisplay.textContent = `${selectedVariants.length} of ${maxFlavors} selected`;
    }

    // Calculate and display total
    const total = selectedVariants.length * pricePerPack;
    const finalTotal = selectedVariants.length === maxFlavors ? total - 10 : total;

    if (totalPriceDisplay) {
      if (selectedVariants.length === maxFlavors) {
        totalPriceDisplay.innerHTML = `
          <span style="text-decoration: line-through; color: #888; margin-right: 8px;">
            $${total.toFixed(2)}
          </span>
          <strong style="color: #000;">$${finalTotal.toFixed(2)}</strong>
        `;
      } else {
        totalPriceDisplay.textContent = `Total: $${finalTotal.toFixed(2)}`;
      }
    }

    // Enable or disable Add to Cart button
    addToCartBtn.disabled = selectedVariants.length !== maxFlavors;

    // Show or hide discount note
    if (discountNote) {
      if (selectedVariants.length === maxFlavors) {
        discountNote.innerHTML = "🎉 <strong>$10 off</strong> will be applied at checkout!";
        discountNote.style.display = "block";
      } else {
        discountNote.innerHTML = "";
        discountNote.style.display = "none";
      }
    }
  }

  function addVariant(id, title, subtitle, image) {
    if (selectedVariants.length >= maxFlavors) return;
    selectedVariants.push({ id, title, subtitle, image });
    updateTracker();
  }

  productGrid.addEventListener("click", function (e) {
    if (e.target.classList.contains("add-to-bundle")) {
      const id = e.target.getAttribute("data-id");
      const title = e.target.getAttribute("data-title");
      const subtitle = e.target.getAttribute("data-subtitle");
      const image = e.target.getAttribute("data-image");
      addVariant(id, title, subtitle, image);
    }
  });

  trackerList.addEventListener("click", function (e) {
    if (e.target.classList.contains("remove-item")) {
      const index = parseInt(e.target.getAttribute("data-index"));
      selectedVariants.splice(index, 1);
      updateTracker();
    }
  });

  addToCartBtn.addEventListener("click", function () {
    if (selectedVariants.length !== maxFlavors) return;
  
    const itemsToAdd = selectedVariants.map(item => ({
      id: item.id,
      quantity: 1
    }));
  
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: itemsToAdd })
    })
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok.');
      return response.json();
    })
    .then(() => {
      window.location.href = '/cart';
    })
    .catch(error => {
      console.error('Error adding items to cart:', error);
    });
  });
  
  renderProducts();
  updateTracker();
});
